export default __webpack_public_path__ + "static/media/gallery10.9fea54aa.jpg";